import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { initI18next } from '@forto-dev/platform-localisation'

import { App } from './app'
import { initRum } from './utils/monitoring'
import { ThemeProvider } from './utils/theme'

import './index.css'

initI18next()
initRum()

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
)
